// @ngInject
const config = ($stateProvider) => {
  $stateProvider.state('shipments', {
    parent: 'main',
    url: '/shipments',
    views: {
      'main-content': {
        template: '<transport-requests></transport-requests>',
      },
    },
    data: { pageTitle: 'Shipments' },
  });
};

angular.module('main.shipments', []).config(config);
